import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {
  PersonStaffGroupAudit,
  PersonStaffGroupSkeleton
} from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-person-staff-groups-audit-list',
  templateUrl: './person-profile-person-staff-groups-audit-list.component.html',
  styleUrls: ['./person-profile-person-staff-groups-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfilePersonStaffGroupAuditListComponent implements OnInit {
  @Input() personStaffGroup: PersonStaffGroupSkeleton;
  @Input() loading: boolean;
  @Input() personStaffGroupAudits: PersonStaffGroupAudit[];

  @Output() loadPersonStaffGroupAudits: EventEmitter<number> = new EventEmitter<number>();
  @Output() nextPage: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPersonStaffGroupAudits.emit(this.personStaffGroup.personStaffGroupId);
  }

  onNextPage() {
    this.nextPage.emit(this.personStaffGroup.personStaffGroupId);
  }
}
